import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPublicPageView } from "../services/publicAnalytics";

/**
 * Fires a first-party page view on every route change. The service itself
 * decides whether the path is a tracked public marketing page and no-ops for
 * bots / prerender / localhost, so this hook stays unconditional.
 */
export default function usePublicPageViews() {
  const { pathname } = useLocation();

  useEffect(() => {
    trackPublicPageView(pathname);
  }, [pathname]);
}
